import AppHeaders              from './../classes/Headers.js';
import fetch                   from 'isomorphic-fetch';
import { getConfig }           from './../classes/Config';
import { updateFavourite }     from './PlaceAction';
import { sendMessage }         from './MessageAction';
import { updateFavourites }    from './FilterAction'

export const RECEIVE_USER     = 'RECEIVE_USER';
export const ADD_FAVOURITE    = 'ADD_FAVOURITE';
export const REMOVE_FAVOURITE = 'REMOVE_FAVOURITE';

export const receiveUser = (user) => {
    return (dispatch) => {
        dispatch({
            type: RECEIVE_USER,
            user: user
        });
    };
};

export const favourite = (user) => {
    return {
        type: ADD_FAVOURITE,
        user: user
    }

};

export const unFavourite = (user) => {
    return {
        type: REMOVE_FAVOURITE,
        user: user
    }
};

/**
 * Send a message to the message component.
 * Dispatch favourite action
 * Dispatch update favourite action
 * Reset the favourite filter
 *
 * @param json
 * @param dispatch
 * @param getState
 */
const handleFavourite = (json, dispatch) => {
    if (2 === json.code)
    {
        dispatch(sendMessage('Favourite added'));
    }

    new Promise(
        (resolve) => {
            dispatch(updateFavourite(true));
            resolve(json.data.user);
        }).then((user) => {
            dispatch(favourite(user));
            return user;
        }).then((user) => {
            dispatch(updateFavourites(user));
    });
};

export const addFavourite = (place) =>
{
    return (dispatch, getState) =>
    {
        let body = { userId: getState().user.id };
        if (place.type === 'trail')
        {
            body.trailId = place.id;
        }
        else
        {
            body.placeId = place.id;
        }

        let auth    = getState().auth;
        let headers = new AppHeaders().getHeaders(auth.token);

        const AssetsRequest = new Request(getConfig('API_ROOT') + '/places/favourite', {
            method : 'POST',
            mode   : 'cors',
            headers: headers,
            body   : JSON.stringify(body)
        });

        return fetch(AssetsRequest)
            .then(response => response.json())
            .then(json => {
                handleFavourite(json, dispatch);
            });
    }
};

/**
 * Send a message to the message component.
 * Dispatch un-favourite action
 * Dispatch update favourite action
 * Reset the favourite filter
 *
 * @param json
 * @param dispatch
 * @param getState
 */
const handleRemoveFavourite = (json, dispatch) => {
    if (2 === json.code)
    {
        dispatch(sendMessage('Favourite removed'));
    }

    new Promise(
        (resolve) => {
            dispatch(updateFavourite(false));
            resolve(json.data.user);
        }).then((user) => {
            dispatch(unFavourite(user));
            return user;
        }).then((user) => {
            dispatch(updateFavourites(user));
        });
};

export const removeFavourite = (place) =>
{
    return (dispatch, getState) =>
    {
        let body = { userId: getState().user.id };
        if (place.type === 'trail')
        {
            body.trailId = place.id;
        }
        else
        {
            body.placeId = place.id;
        }

        let auth    = getState().auth;
        let headers = new AppHeaders().getHeaders(auth.token);

        const AssetsRequest = new Request(getConfig('API_ROOT') + '/places/un-favourite', {
            method : 'POST',
            mode   : 'cors',
            headers: headers,
            body   : JSON.stringify(body)
        });

        return fetch(AssetsRequest)
            .then(response => response.json())
            .then(json => {
                handleRemoveFavourite(json, dispatch);
            });
    }
};



// WEBPACK FOOTER //
// ./src/actions/UserAction.js